import React from 'react';
import { Menu } from '@headlessui/react';
import cx from 'classnames';

import { defaultDisabled, defaultSize } from './constants';

/**
 * A dropdown option which accepts an `option` property. Intended for use within Dropdown.
 * @param {DropdownOptionProps<V>} props
 */
export function DropdownOption<V>(props: DropdownOptionProps<V>): JSX.Element {
    const {
        dataCy,
        handleChange,
        height,
        leftPadding = true,
        option,
        size = defaultSize,
        underlineOnHover = true,
    } = props;
    const { label } = option;
    const disabled = props.disabled || (option?.disabled ?? defaultDisabled);

    return (
        <Menu.Item disabled={disabled}>
            {({ active }): JSX.Element => (
                <button
                    type="button"
                    className={cx(
                        'dropdown-menu-item flex items-center text-left font-semibold w-full respond-to-mouse',
                        size,
                        {
                            'hover:underline':
                                underlineOnHover &&
                                !disabled &&
                                size !== 'small',
                            'bg-gray-100 text-gray-900': active,
                            'text-gray-700': !active,
                            'cursor-default': disabled,
                        },
                    )}
                    data-cy={dataCy}
                    disabled={disabled}
                    onClick={(): void => {
                        handleChange(option);
                    }}
                    style={{ height }}
                >
                    <div
                        className={cx('w-full', {
                            'text-tertiary-300': disabled,
                            'pl-2': leftPadding,
                        })}
                    >
                        {label}
                    </div>
                </button>
            )}
        </Menu.Item>
    );
}
